import React, { Component } from 'react'
import { connect } from 'react-redux'
import appConfig from '../../config/app'
import { Link } from 'react-router'

import Share from '../share/Share'
import StepButton from '../step-button/StepButton'

class ShareScreen extends Component {
  static defaultProps = {
    generated: {}
  }

  constructor(props) {
    super(props)
    this.state = {
      postcard: JSON.parse(localStorage.getItem('postcard'))
    }
  }

  componentWillMount(newProps) {
    let localPostcard = JSON.parse(localStorage.getItem('postcard'))

    if(typeof localPostcard.thumb_path === undefined || localPostcard.thumb_path === "") {
      localPostcard.thumb_path = this.props.generated.thumb_image
      localPostcard.short_link = this.props.generated.short_link
      localPostcard.origin_image = this.props.generated.origin_image

      localStorage.setItem('postcard', JSON.stringify(localPostcard));   

      this.setState({
        postcard: {
          ...this.state.postcard,
          thumb_path: localPostcard.thumb_path,
          short_link: localPostcard.short_link,
          origin_image: localPostcard.origin_image
        }
      })  
    } 
  }

  handleStorageClean = () => {
    localStorage.setItem('postcard', JSON.stringify({
      "gender": 1,
      "type": 1,
      "text": 1,
      "startPhrase": "",
      "name": "",
      "background": 1,
      "thumb_path": "",
      "short_link": "",
      "origin_image": "",
    }))
  }

  render() {
    const { postcard } = this.state

    return (
      <div>
        <h1 className="blue" style={{marginBottom: 0}}>Иконки соцсетей позволят отправить открытку <span className="animated-span">личным сообщением</span> или на стену</h1>

        <div className="postcard-holder">
          
        <div className="card-overlay">
          <Share card={postcard}/>
          <span style={{display: 'inline-block', paddingTop: '10px'}}>поделись или скопируй:</span>
          <Link className="card-link" to={`/postcard/${postcard.short_link}`}>
          {`${appConfig.basePath}postcard/${postcard.short_link}`}
          </Link>
        </div>
          <img style={{width: '565px', height: 'auto'}} role="presentation" src={appConfig.basePath+postcard.origin_image} />
          
        </div>
        <p style={{marginBottom: '15px'}}>Никого ли ты не забыл? У нас в запасе много поздравлений!</p>

        <StepButton title="Создать еще открытку" onNavigate={this.handleStorageClean} navigateTo="settings"/>
      </div>
    );
  }
}

export default connect((state) => ({
  generated: state.postcard.data
}))(ShareScreen)


// WEBPACK FOOTER //
// ./src/components/postcard/ShareScreen.js